import { FC } from 'react'
import { AdditionalServicesProtocol } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesProtocolPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesProtocol />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesProtocolPage
